import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { timer } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FullstoryTestingCookieService {
  public isTestingFullStory$ = timer(0, 1000).pipe(
    map(() => this.hasFsTestingCookie()),
    distinctUntilChanged()
  );

  constructor(private cookieService: CookieService) {}

  public hasFsTestingCookie(): boolean {
    return this.cookieService.check('fs_testing');
  }

  // Add cookie that will expire in 24hrs
  public setFsTestingCookie() {
    this.cookieService.set(
      'fs_testing',
      'true',
      new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
      '/'
    );
  }

  public deleteFsTestingCookie() {
    this.cookieService.delete('fs_testing', '/');
  }
}
